module.exports = __webpack_public_path__ + "static/media/claudio_echeverri.e5626f0d.jpg";